import React from "react";

const HeaderTopRecentMatches = () => {
  return (
    <React.Fragment>
      <div className="block @md:flex bg-header-blue dark:bg-dark-slate mb-2 items-center justify-between rounded-md w-full gap-x-0">
        <div className="flex flex-wrap items-center justify-between gap-0">
          <div className="flex flex-wrap gap-0 ml-3">
            <div className="w-[1.5rem] py-1"></div>
          </div>
          <div className="flex flex-wrap gap-0 mx-0 @xl:mx-3">
            <div className="w-[2rem] @md:w-[4rem] py-1 mx-1">
              <div className="flex-1 flex items-center justify-center text-button-blue-bet dark:text-stroke-o3 text-xs font-semi-bold">Giờ</div>
            </div>
          </div>
          <div className="flex flex-wrap gap-0 mr-0 @xl:mr-3">
            <div className="flex gap-0">
              <div className="w-[2rem] @md:w-12"></div>
              <div className="w-12">
               <div className="flex-1 flex items-center text-button-blue-bet text-xs dark:text-stroke-o3 font-semi-bold">Giải</div>
              </div>
            </div>
            <div className="flex gap-0">
              <div className="w-[1.5rem]">
                <div className="flex-1 flex items-center justify-center text-button-blue-bet text-xs font-semi-bold"></div>
              </div>
            </div>
            <div className="flex gap-0">
              <div className="min-w-10 @md:w-[13rem]">
                <div className="text-button-blue-bet text-xs dark:text-stroke-o3 font-semi-bold">Đội</div>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-0 mr-1 @xl:mr-3">
            <div className="flex-1 @md:w-[4rem] flex items-center justify-center text-button-blue-bet text-xs dark:text-stroke-o3 font-semi-bold w-[4rem] text-ellipsis overflow-hidden whitespace-nowrap">Tỉ số/Thẻ</div>
          </div>
          <div className="flex flex-wrap gap-0 ml-3">
            <div className="w-[2.5rem]">
              <div className="flex-1 flex items-center justify-center text-button-blue-bet text-xs dark:text-stroke-o3 font-semi-bold">Góc</div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HeaderTopRecentMatches;